import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconReplyComponent } from "./med-icon-reply.component";

@NgModule({
  declarations: [
    MedIconReplyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconReplyComponent,
  ],
})
export class MedIconReplyModule { }
